import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'cancellation_reasons',
  inputShow: gql`
    query cancellationReasons($input: CancellationReasonQueryInput) {
      cancellationReasons(input: $input) {
        id
        label
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    label: 'Cancellation Reasons',
    group: 'Misc',
  },
};
